import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: '[app-nav-administration]',
  standalone: true,
  imports: [RouterLink],
  template: `
    @if (authService.hasPermission('can_read_users')) {
      <li><button routerLink="/users" [class.active]="currentView === 'users'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Administradores</button></li>
    }
    @if (authService.hasPermission('can_read_companies')) {
      <li><button routerLink="/perfiles" [class.active]="currentView === 'perfiles'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Perfiles</button></li>
    }
    @if (authService.hasPermission('can_read_roles')) {
      <li><button routerLink="/roles" [class.active]="currentView === 'roles'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Roles y permisos</button></li>
    }
    @if (authService.hasPermission('can_read_permissions')) {
      <li><button routerLink="/permissions" [class.active]="currentView === 'catalogs'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Permisos</button></li>
    }

    <li class="notification-settings-heading">Configuración de<br>Notificaciones</li>
    <li>
      <button
        routerLink="/users/notifications/irregular-consumptions"
        [class.active]="currentView === 'consumption-notifications'"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">
        Consumos irregulares
      </button>
    </li>
    <li>
      <button
        routerLink="/users/notifications/anova-readings"
        [class.active]="currentView === 'anova-notifications'"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">
        Lecturas de Anova
      </button>
    </li>
    <li>
      <button
        routerLink="/users/notifications/contracts"
        [class.active]="currentView === 'contract-notifications'"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">
        Contratos
      </button>
    </li>
  `,
  styles: `
    .notification-settings-heading {
      margin: 1.25rem 0.75rem 1rem;
      color: var(--bs-body-color);
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 1.15;
    }
  `
})
export class NavAdministrationComponent {
  @Input() currentView: string | null = null;

  constructor(
    public authService: AuthService
  ) {}
}
